// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2mc7P","obliqueLineWrap":"membershipbadge_obliqueLineWrap__XmcMW","obliqueLine":"membershipbadge_obliqueLine__2ydYA"};